/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const i18n = createInstance();

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        // Two namespaces:
        //   - `translation` (default): shared keys used by the legacy portal
        //     and the rest of mportal.
        //   - `dfe`: keys exclusive to the Dynamic Flow Editor (every key
        //     prefixed `editor_*`). Lives in `public/locales/{{lng}}/dfe.json`.
        //
        // `fallbackNS: 'dfe'` means a lookup like `t('editor_save')` is
        // first tried in `translation` and, if missing, falls through to
        // `dfe`. This keeps every existing `useTranslation()` call in
        // editor components working unchanged — no namespace argument needed.
        ns: ['translation', 'dfe'],
        defaultNS: 'translation',
        fallbackNS: 'dfe',
        react: {
            useSuspense: true,
        },
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;
